import * as React from 'react';
import clsx from 'clsx';
import checkedIcon from '@/assets/images/svg/checked_icon.svg';

interface ConsentCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  /** Additional classes applied to the outer label wrapper. */
  className?: string;
  /** Additional classes applied to the label text span. */
  labelClassName?: string;
}

/** Reusable styled consent checkbox with custom check icon. */
export const ConsentCheckbox: React.FC<ConsentCheckboxProps> = ({
  checked,
  onChange,
  label,
  className,
  labelClassName,
}) => (
  <label
    className={clsx(
      'flex cursor-pointer items-center gap-3',
      'rounded-10 border border-gray-310 bg-gray-100',
      'p-4',
      'transition-colors hover:bg-gray-200',
      className
    )}
  >
    <input
      type='checkbox'
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      className='peer sr-only'
    />
    <div className='relative flex size-5 shrink-0 items-center justify-center'>
      {checked ? (
        <img src={checkedIcon} alt='Checked' className='size-full object-contain' />
      ) : (
        <div className='size-full rounded border border-gray-300 bg-white' />
      )}
    </div>
    <span
      className={clsx('font-sans text-16 font-semibold leading-21 text-gray-600', labelClassName)}
    >
      {label}
    </span>
  </label>
);
